import ReactLoading, { LoadingProps } from 'react-loading';
import { mppColorBrandPrimaryMedium as mppColorBrandPrimaryMediumAlicorp } from '@pu/mpp-design-tokens/build/web/theme-alicorp/tokens';
import { mppColorBrandPrimaryMedium as mppColorBrandPrimaryMediumDiaDia } from '@pu/mpp-design-tokens/build/web/theme-diadia/tokens';
import { mppColorBrandPrimaryMedium as mppColorBrandPrimaryMediumInsuma } from '@pu/mpp-design-tokens/build/web/theme-insuma/tokens';
import { EChannel } from 'core/model/enums/channel.enum';
import { authChannelSelector } from 'core/store/auth/selectors';
import { useAppSelector } from 'core/store/store.utils';
import { getChannel } from 'core/utils/channel.utils';

import './loading.scss';

export const Loading = ({ color, type = 'spin', ...props }: LoadingProps) => {
  const channel = useAppSelector(authChannelSelector);

  const channelId = channel?.id || getChannel();

  const getColorDefault = () => {
    if (color) return color;
    if (Number(channelId) === EChannel.DIADIA) return mppColorBrandPrimaryMediumDiaDia;
    if (Number(channelId) === EChannel.INSUMA) return mppColorBrandPrimaryMediumInsuma;

    return mppColorBrandPrimaryMediumAlicorp;
  };

  return (
    <div className="mpp-loading">
      <ReactLoading type={type} color={getColorDefault()} {...props} />
    </div>
  );
};
